import { lineStyles } from '../render-graph/lineStyles.ts';
import { LabelWithBorder } from './labelWithBorder.tsx';
import { MeasurementGraphSettings } from './measurementGraphSettings.ts';


interface Props {
    style?: React.CSSProperties;
    settings: MeasurementGraphSettings,
    setSettings: (settings: MeasurementGraphSettings) => void,
}

export function MeasurementGraphControl({
    style,
    settings,
    setSettings,
}: Props) {

    const handleCheckboxChange = (key: keyof MeasurementGraphSettings['lineVisibilities']) => {
        setSettings({
            ...settings,
            lineVisibilities: {
                ...settings.lineVisibilities,
                [key]: !settings.lineVisibilities[key],
            }
        });
    }


    const labelStyle: React.CSSProperties = { padding: '2px 13px 4px 10px', borderWidth: '2px' };
    const checkBoxStyle: React.CSSProperties = { marginRight: '6px' };

    return (
        <div style={{
            ...style,
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: '24px',
            padding: '0px 20px',
        }}>
            <LabelWithBorder
                style={labelStyle}
                borderBottomColor={lineStyles.nominal.color}
                borderBottomDashArray={lineStyles.nominal.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.nominal ?? false}
                    onChange={() => handleCheckboxChange('nominal')}
                />
                Nominal
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderBottomColor={lineStyles.tolerance.color}
                borderBottomDashArray={lineStyles.tolerance.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.tolerance ?? false}
                    onChange={() => handleCheckboxChange('tolerance')}
                />
                Tolerance
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderBottomColor={lineStyles.mean.color}
                borderBottomDashArray={lineStyles.mean.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.mean ?? false}
                    onChange={() => handleCheckboxChange('mean')}
                />
                Mean
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderBottomColor={lineStyles.sigma1.color}
                borderBottomDashArray={lineStyles.sigma1.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.sigma1 ?? false}
                    onChange={() => handleCheckboxChange('sigma1')}
                />
                1σ
            </LabelWithBorder>
            <LabelWithBorder
                style={{ ...labelStyle }}
                borderBottomColor={lineStyles.sigma2.color}
                borderBottomDashArray={lineStyles.sigma2.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.sigma2 ?? false}
                    onChange={() => handleCheckboxChange('sigma2')}
                />
                2σ
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderBottomColor={lineStyles.sigma3.color}
                borderBottomDashArray={lineStyles.sigma3.dashArray}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.sigma3 ?? false}
                    onChange={() => handleCheckboxChange('sigma3')}
                />
                3σ
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderRightColor={lineStyles.batchStart.color}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.batchStarts ?? false}
                    onChange={() => handleCheckboxChange('batchStarts')}
                />
                Batches
            </LabelWithBorder>
            <LabelWithBorder
                style={labelStyle}
                borderRightColor={lineStyles.operation.color}
            >
                <input
                    style={checkBoxStyle}
                    type='checkbox'
                    checked={settings.lineVisibilities.operations ?? false}
                    onChange={() => handleCheckboxChange('operations')}
                />
                Tool changes
            </LabelWithBorder>
        </div >
    )
}
